import * as React from 'react'

function LogoDelcred(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      id='Layer_2'
      data-name='Layer 2'
      viewBox='0 0 508.41 84.9'
      width={'100%'}
      height={'100%'}
      {...props}
    >
      <defs>
        <style>
          {'.cls-1 {fill: #000;}.cls-1, .cls-2 {stroke-width: 0px;}.cls-2 {fill: #00e600;}'}
        </style>
      </defs>
      <g id='Layer_2-2' data-name='Layer 2'>
        <g>
          <path
            className='cls-2'
            d='M55.3,79.2c-9.4,3.8-18,5.7-25.8,5.7-9.4,0-16.7-3-21.8-9-5.1-6-7.7-13.3-7.7-22s2.6-15.9,7.8-21.9c5.2-6,12.4-9,21.8-9,3.4,0,7.4.4,11.8,1.3V1.5l13.9-1v78.7h0ZM18.6,66.9c2.7,3.5,6.5,5.2,11.4,5.2,4.1,0,7.9-.9,11.4-2.6v-31.5c-3.9-1.4-7.8-2.2-11.4-2.2-4.8,0-8.6,1.8-11.3,5.4-2.7,3.6-4.1,7.9-4.1,12.9s1.3,9.3,4,12.8h0Z'
          />
          <path
            className='cls-2'
            d='M105,26c3.8,2.1,6.7,4.9,8.8,8.4s3.6,7.2,4.6,11.3c.9,4,1.2,8.1.9,12.3h-42.6c.7,4.2,2.5,7.6,5.2,10.3,2.8,2.7,6.4,4.1,10.8,4.1s8.9-1.1,13.4-3.3l6.8,10.1c-5.8,3.9-12.7,5.8-20.6,5.7-9.8,0-17.2-3-22.4-9-5.2-6-7.8-13.4-7.8-22.2s2.6-15.9,7.6-21.9c5.1-6,12.5-8.9,22.1-8.9,5,0,9.4,1,13.2,3.1h0ZM104.8,48c-.1-1.4-.5-3-1.2-4.8s-2.2-3.5-4.4-5.2c-2.2-1.7-5-2.5-8.2-2.5-4,0-7.2,1.1-9.5,3.4-2.3,2.3-3.9,5.3-4.7,9.1h28Z'
          />
          <path
            className='cls-1'
            d='M170.1,14.8c-1.4,2-2.3,5-2.5,8.8h16.3l-.9,11.4h-15.5v48.9h-13.9V23.7c0-7,1.8-12.7,5.5-17.1,3.7-4.4,8.4-6.6,14.2-6.6,4.5,0,8.3.5,11.3,1.5v11.2c-2.4-.7-4.8-1-7-1-3.6,0-6.1,1.1-7.5,3.1h0Z'
          />
          <path
            className='cls-1'
            d='M192.9,16.3c-1.6-1.6-2.4-3.6-2.4-5.9s.8-4,2.4-5.6c1.6-1.6,3.4-2.4,5.6-2.4s4,.8,5.6,2.4c1.6,1.6,2.4,3.4,2.4,5.6,0,2.4-.8,4.3-2.4,5.9s-3.4,2.4-5.6,2.4-4-.8-5.6-2.4ZM205.3,83.9h-13.9V23.6h13.9v60.3Z'
          />
          <path
            className='cls-1'
            d='M261,29.3c5.5,4.3,8.2,9.9,8.2,16.8v37.9h-13.9v-34.3c0-4-1.2-7.3-3.7-9.7s-5.7-3.7-9.5-3.7c-3,0-6.6.6-10.9,1.8v45.8h-13.9V28.5c9.4-3.8,17.9-5.7,25.5-5.7,6.6.1,12.7,2.2,18.2,6.5h0Z'
          />
          <path
            className='cls-1'
            d='M318.8,29.3c4.8,4.3,7.2,9.8,7.2,16.6v33.7c-3,1.3-5.2,2.2-6.6,2.7s-3.5,1.1-6.4,1.7c-2.9.6-5.9.9-9.1.9-9.1,0-16-1.8-20.6-5.4-4.6-3.6-7-8.8-7-15.6,0-3.7.9-7,2.8-9.7s4.3-4.7,7.3-6,6-2.3,8.8-2.9c2.9-.6,5.7-.9,8.6-.9,3.2,0,6.1.3,8.7.9-.6-7.2-4.4-10.8-11.5-10.9-5.3,0-10,.8-13.9,2.3l-4.5-9.9c5.5-2.7,11.9-4,19.1-4,6.7,0,12.3,2.2,17.1,6.5h0ZM304,73.2c2.9,0,5.9-.4,8.8-1.3v-15.8c-2.9-.6-5.8-1-8.7-1-9.8,0-14.7,2.9-14.7,8.8,0,5.9,4.9,9.3,14.6,9.3h0Z'
          />
          <path
            className='cls-1'
            d='M378.5,29.3c5.5,4.3,8.2,9.9,8.2,16.8v37.9h-13.9v-34.3c0-4-1.2-7.3-3.7-9.7s-5.7-3.7-9.5-3.7c-3,0-6.6.6-10.9,1.8v45.8h-13.9V28.5c9.4-3.8,17.9-5.7,25.5-5.7,6.6.1,12.7,2.2,18.2,6.5h0Z'
          />
          <path
            className='cls-1'
            d='M445.8,75c-2.7,3-5.8,5.4-9.2,7.2s-7.8,2.6-13.2,2.6c-9.6,0-17-3-22.2-9s-7.8-13.4-7.8-22.1,2.6-15.9,7.8-21.9c5.2-6,12.6-8.9,22.2-8.9,4.4,0,8.5.8,12.4,2.4,3.9,1.6,7,3.8,9.5,6.8l-9.6,9.4c-3.7-3.9-7.8-5.8-12.2-5.8-5,0-8.9,1.7-11.6,5.2s-4.1,7.8-4.1,13,1.4,9.3,4,12.8c2.7,3.5,6.5,5.3,11.6,5.3,1.9,0,3.8-.4,5.5-1.2,1.8-.8,3-1.5,3.6-2s1.7-1.5,3-2.7l10.3,8.9h0Z'
          />
          <path
            className='cls-1'
            d='M494,26c3.8,2.1,6.7,4.9,8.8,8.4,2.1,3.5,3.6,7.2,4.6,11.3.9,4,1.2,8.1.9,12.3h-42.6c.7,4.2,2.5,7.6,5.2,10.3,2.8,2.7,6.4,4.1,10.8,4.1s8.9-1.1,13.4-3.3l6.8,10.1c-5.8,3.9-12.7,5.8-20.6,5.7-9.8,0-17.2-3-22.4-9-5.2-6-7.8-13.4-7.8-22.2s2.6-15.9,7.6-21.9c5.1-6,12.5-8.9,22.1-8.9,5.1,0,9.4,1,13.2,3.1h0ZM493.8,48c-.1-1.4-.5-3-1.2-4.8s-2.2-3.5-4.4-5.2c-2.2-1.7-5-2.5-8.2-2.5-4,0-7.2,1.1-9.5,3.4-2.3,2.3-3.9,5.3-4.7,9.1h28Z'
          />
          <polygon
            className='cls-2'
            points='141.1 60.2 141.1 36.6 141.1 .4 127.2 1.4 127.2 83.9 141.1 83.9 141.1 60.2'
          />
        </g>
      </g>
    </svg>
  )
}

export default LogoDelcred
